import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SecurityService } from '../../services/security.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  roleName:string='';
  functions:string='';
  public env: string= `${environment.environmentName}`;

  constructor(public securityService:SecurityService) { }

  ngOnInit(): void {
    if(this.securityService.isUserAuthorized){
      this.roleName=this.securityService.LOGGED_USER.roles?.join('')?? '';
      let functionCodes=this.securityService.LOGGED_USER.functionCodes?? new Array<string>() ;
      for(var functionCode in functionCodes){
        this.functions=this.functions.concat(functionCode).trim().concat(' ,');
      }
      console.log("functions====" + this.functions);
    }
  }
}


